/*
* 将HTTP的美团Venus图片URL 转成HTTPS
**/

module.exports = function (httpUrl) {
    if (!httpUrl) {
        httpUrl = '';
    }
    return httpUrl.replace(/^http:\/\/(p0|p1|img)\.meituan\.net\//, 'https://img.meituan.net/');
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/picConverter.js
// module id = 273
// module chunks = 0